import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloneMenuComponent } from './clone-menu.component';

import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CloneMenuComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
  ],
  exports: [CloneMenuComponent],
})
export class CloneMenuModule {}
